export const infoTooltipStyles = {
    trigger: {
        display: 'inline-flex',
        alignItems: 'center',
        padding: '0',
        background: 'transparent',
        '& svg': {verticalAlign: 'top'}
    },
    content: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        width: 'fit-content',
        '--info-tooltip-bg': 'colors.black',
        '--info-tooltip-max-width': 'sizes.info-tooltip-full-width',
        bg: 'var(--info-tooltip-bg)',
        maxWidth: 'min(var(--info-tooltip-max-width), calc(100vw - {spacing.spacing-32}))',
        paddingBlock: 'spacing-10',
        paddingInline: 'spacing-8',
        gap: 'spacing-8',
        color: 'primary.base.white',
        border: 'none',
        borderRadius: 'sm',
        boxShadow: 'none',
        textStyle: 'body.small',
        '&[data-show-close="true"]': {paddingInlineEnd: '24px'}
    },
    arrow: {
        '--arrow-size': 'sizes.3',
        '--arrow-background': 'var(--info-tooltip-bg)'
    },
    arrowTip: {border: '0'},
    closeTrigger: {
        position: 'absolute',
        top: '7px',
        insetEnd: '8px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxSize: '16px',
        minWidth: '16px',
        minHeight: '16px',
        padding: '0',
        borderRadius: 'md',
        color: 'inherit',
        fontSize: '2xs',
        '& svg': {boxSize: '1em'},
        _focusVisible: {outline: '2px solid', outlineOffset: '2px'}
    },
    header: {
        padding: '0',
        '&[data-show-close="true"]': {paddingInlineEnd: '24px'}
    },
    body: {
        padding: '0',
        display: 'flex',
        flexDirection: 'column',
        gap: '2',
        '& ul': {paddingInlineStart: '4', listStyleType: 'disc'},
        '&[data-show-close="true"]': {paddingInlineEnd: '24px'}
    }
}

export const infoTooltipSizes = {
    compact: {content: {'--info-tooltip-max-width': 'sizes.info-tooltip-compact-width'}},
    wide: {content: {'--info-tooltip-max-width': 'sizes.info-tooltip-wide-width'}},
    full: {content: {'--info-tooltip-max-width': 'sizes.info-tooltip-full-width'}}
}
